import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionCustom } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { GridComp126, GridComp6 } from "../../../components/GridComponents";
import {
  salesOrderFAMDepreciationHistoryTable,
  salesOrderFamAssetTable,
  salesOrderCustomJournalRejectReasonTable,
  invoiceFamAssetTable,
  invoiceCustomJournalRejectReasonTable,
  invoiceFAMDepreciationHistoryTable,
  BgSummaryrecordTable,
  BgIncomeTable,
  BgDeprecitionHistoryTable,
  BgFAMAssetTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { CustomCheckBox } from "../../../components/CheckboxComp";
import { GridComp4 } from "../../../components/GridComponents";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));

export default function InvoiceCustom({ tabIndexP }) {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState({});
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  useEffect(() => {
    if (user.token && tabIndexP === 6) {
      getTransactionCustomData();
    }
  }, [tabIndexP]);

  async function getTransactionCustomData() {
    setLoading(false);
    try {
      const { data } = await getTransactionCustom(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Box className="viewDetilsBox">
      <Grid container spacing={1}>
    <Grid item xs={12} sm={4} md={4}>
      <GridComp126
        title="GP TRANSACTION ID"
        data={rowData.gp_transaction_id}
      />
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
      <GridComp126
        title="PC/PROJECT VP"
        data={rowData.pc_project_vp}
      />
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
      <GridComp126
        title="PC/PROJECT SELECT"
        data={rowData.pc_project_select}
      />
    </Grid>

    <Grid item xs={12} sm={4} md={4} className="m-b-10">
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
            checked={
              rowData.gp_34_entry_transaction ==="T"
                ? true
                : false
            }
            />
          }
          label="GP 3.4M ENTRY TRANSACTION"
        />
      </FormGroup>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
            checked={
              rowData.open_ap_transaction ==="T"
                ? true
                : false
            }
             
            />
          }
          label="OPEN AP TRANSACTION 12/31"
        />
      </FormGroup>
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
    <GridComp126
      title="REJECT REASON"
      data={rowData.reject_Reason}
    />
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
   <GridComp126
      title="CONCUR INVOICE NAME"
      data={rowData.concur_invoice_name}
    />
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
   <GridComp126
      title="CORPORATE APPROVAL"
      data={rowData.corporate_approval}
    />
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
   <GridComp126
      title="PC/PROJECT EVP"
      data={rowData.project_evp}
    />
</Grid>
<Grid item xs={12} sm={4} md={4}>
   <GridComp126
      title="CONCUR ID"
      data={rowData.concur_id}
    />
  </Grid>
  <Grid item xs={12} sm={4} md={4}>
   <GridComp126 title="REJECTING EMPLOYEE" data={rowData.business_unit} />
   </Grid>
   <Grid item xs={12} sm={4} md={4}>
    <GridComp126
      title="VENDOR BILL ATTACHED NAME"
      data={rowData.openair_expense_report_creator}
    />
</Grid>
    <Grid item xs={12} sm={4} md={4} className="m-b-10">
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                rowData.to_delete ==="T"
                  ? true
                  : false
              }
            />
          }
          label="TO DELETE"
        />
      </FormGroup>
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
   <GridComp126
      title="PC/PROJECT DIRECTOR"
      data={rowData.pc_project_director}
    />
    </Grid>
  </Grid>

        <Tabs
          value={tabIndexRelatedRecord}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndexRelatedRecord(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-sub-bkg`}
          // className="tabs-sub-bkg"
        >
          <Tab label="BG Summary Records" />
          <Tab label="FAM Expense/Income" />
          <Tab label="FAM Depreciation History" />
          <Tab label="FAM Asset" />
        </Tabs>
        <TabPanel value={tabIndexRelatedRecord} index={0}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  BG Summary Records
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New BG Summary Records</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgSummaryrecordTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={1}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  FAM Expense/Income
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Expense/Income</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgIncomeTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={2}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  FAM Depreciation History
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">
                New FAM Depreciation History
              </Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgDeprecitionHistoryTable}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={3}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">FAM Asset</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Asset</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgFAMAssetTable}
            refreshCounter={0}
          />
        </TabPanel>
      </Box>
    </>
  );
}

// import React from "react";
// import { useSelector } from "react-redux";
// import { useState, useEffect } from "react";
// import useSnackbar from "../../../hooks/useSnackbar";
// import { getTransactionCustom } from "../../../api/transaction-type";
// import { slugMap } from "../../../config/slug-config";
// import { useParams } from "react-router-dom";
// import {
//   Box,
//   Grid,
//   Checkbox,
//   FormControl,
//   FormControlLabel,
//   FormGroup,
//   CircularProgress,
//   Tab,
//   Tabs,
//   InputLabel,
//   TabPanel,
//   Stack,
//   Button,
//   Select,
//   MenuItem
// } from "@mui/material";
// import { BgDeprecitionHistoryTable, BgFAMAssetTable, BgIncomeTable, BgSummaryrecordTable } from "../../../config/grid-column-defs";
// import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
// import { makeStyles } from "@mui/styles";

// const useStyles = makeStyles((theme) => ({
//   spacedTabs: {
//     "& .MuiTab-root": {
//       marginRight: theme.spacing(2), // Adjust the spacing as needed
//     },
//   },
// }));
// export default function BillCreditCustom({ tabIndexP }) {
//   const classes = useStyles();
//   const snackbar = useSnackbar();
//   const { data: user } = useSelector((state) => state.user);
//   const params = useParams();
//   const [loading, setLoading] = useState(false);

//   const pageDetail = slugMap[params.slug];

//   const [rowData, setRowData] = useState([]);
//   const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
//   // const [tableRefreshCount, setTableRefreshCount] = useState(0);
//   // function refreshTable () {
//   //     setTableRefreshCount(prev => prev + 1);
//   // }

//   useEffect(() => {
//     if (user.token && tabIndexP === 6) {
//       getTransactionCustomData();
//     }
//   }, [tabIndexP]);

//   async function getTransactionCustomData() {
//     setLoading(false);
//     try {
//       const { data } = await getTransactionCustom(user.token, {
//         id: params.docNo,
//       });
//       setRowData(data.data.data);
//       setLoading(false);
//     } catch (error) {
//       console.log(error);
//       snackbar.showError("Error In Loading Data.");
//       setLoading(false);
//       return { error: false };
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <>
//       {loading ? (
//         <Grid container className="mb-2">
//           <Grid item xs={12}>
//             <div
//               style={{
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 marginTop: "15px",
//               }}
//             >
//               <CircularProgress />
//             </div>
//           </Grid>
//         </Grid>
//       ) : (
//         <Box className="viewDetilsBox">
//           {rowData?.map((el, i) => (
//             <Grid container spacing={1} key={i}>
//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">GP TRANSACTION ID</p>
//                 <p className="tFormName">{rowData.gp_transaction_id}</p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">PC/PROJECT VP</p>
//                 <p className="tFormName">{rowData.openair_export_error}</p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">PC/PROJECT SELECT</p>
//                 <p className="tFormName">{rowData.openair_export_error}</p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <FormGroup>
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={
//                           rowData.project_sigma_transaction !== "" &&
//                           rowData.project_sigma_transaction !== "F"
//                         }
//                       />
//                     }
//                     label="GP 3.4M ENTRY TRANSACTION"
//                   />
//                 </FormGroup>
//                 <FormGroup>
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={
//                           rowData.project_sigma_transaction !== "" &&
//                           rowData.project_sigma_transaction !== "F"
//                         }
//                       />
//                     }
//                     label="OPEN AP TRANSACTION 12/31"
//                   />
//                 </FormGroup>
//               </Grid>
//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">REJECT REASON</p>
//                 <p className="tFormName">{rowData.openair_expense_report_number}</p>
//               </Grid>
//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">CONCUR INVOICE NAME</p>
//                 <p className="tFormName">{rowData.netsuite_project_id}</p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">CORPORATE APPROVAL</p>
//                 <p className="tFormName">{rowData.netsuite_project_id}</p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">PC/PROJECT EVP</p>
//                 <p className="tFormName">{rowData.netsuite_project_id}</p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">CONCUR ID</p>
//                 <p className="tFormName">
//                   {rowData.openair_expense_approver_supervisor}
//                 </p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">REJECTING EMPLOYEE</p>
//                 <p className="tFormName">{rowData.business_unit}</p>
//               </Grid>

//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">VENDOR BILL ATTACHED NAME</p>
//                 <p className="tFormName">{rowData.openair_expense_report_creator}</p>
//               </Grid>
//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <FormGroup>
//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={
//                           rowData.project_sigma_transaction === "" ||
//                           rowData.project_sigma_transaction === "F"
//                             ? false
//                             : false
//                         }
//                       />
//                     }
//                     label="TO DELETE"
//                   />
//                 </FormGroup>
//               </Grid>
//               <Grid item xs={12} sm={6} md={6} className="m-b-10">
//                 <p className="tFormlabel">PC/PROJECT DIRECTOR</p>
//                 <p className="tFormName">{rowData.openair_export_error}</p>
//               </Grid>
//             </Grid>
//           ))}
//           <Tabs
//           value={tabIndexRelatedRecord}
//           // onChange={handleChange}
//           onChange={(e, nv) => {
//             setTabIndexRelatedRecord(nv);
//           }}
//           variant="scrollable"
//           scrollButtons="auto"
//           aria-label="scrollable auto tabs example"
//           className={`${classes.spacedTabs} tabs-sub-bkg`}
//           // className="tabs-sub-bkg"
//         >
//           <Tab label="BG Summary Records" />
//           <Tab label="FAM Expense/Income" />
//           <Tab label="FAM Depreciation History" />
//           <Tab label="FAM Asset" />
//         </Tabs>
//         <TabPanel value={tabIndexRelatedRecord} index={0}>
//           <Grid container spacing={1} style={{ margin: "1px" }}>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">
//                   BG Summary Records
//                 </InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//           <Box
//             sx={{
//               p: 1,
//             }}
//           >
//             <Stack spacing={2} direction="row">
//               <Button className="blue-button">New BG Summary Records</Button>
//               <Button className="blue-button">Attach</Button>
//               <Button className="blue-button">Customize View</Button>
//             </Stack>
//           </Box>
//           <AgGridPaginatedTable
//             getTableRows={undefined}
//             columns={BgSummaryrecordTable}
//             refreshCounter={0}
//             perPage={5}
//           />
//         </TabPanel>
//         <TabPanel value={tabIndexRelatedRecord} index={1}>
//           <Grid container spacing={1} style={{ margin: "1px" }}>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">
//                   FAM Expense/Income
//                 </InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//           <Box
//             sx={{
//               p: 1,
//             }}
//           >
//             <Stack spacing={2} direction="row">
//               <Button className="blue-button">New FAM Expense/Income</Button>
//               <Button className="blue-button">Attach</Button>
//               <Button className="blue-button">Customize View</Button>
//             </Stack>
//           </Box>
//           <AgGridPaginatedTable
//             getTableRows={undefined}
//             columns={BgIncomeTable}
//             refreshCounter={0}
//             perPage={5}
//           />
//         </TabPanel>
//         <TabPanel value={tabIndexRelatedRecord} index={2}>
//           <Grid container spacing={1} style={{ margin: "1px" }}>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">
//                   FAM Depreciation History
//                 </InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//           <Box
//             sx={{
//               p: 1,
//             }}
//           >
//             <Stack spacing={2} direction="row">
//               <Button className="blue-button">
//                 New FAM Depreciation History
//               </Button>
//               <Button className="blue-button">Attach</Button>
//               <Button className="blue-button">Customize View</Button>
//             </Stack>
//           </Box>
//           <AgGridPaginatedTable
//             getTableRows={undefined}
//             columns={BgDeprecitionHistoryTable}
//             refreshCounter={0}
//           />
//         </TabPanel>
//         <TabPanel value={tabIndexRelatedRecord} index={3}>
//           <Grid container spacing={1} style={{ margin: "1px" }}>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4} md={3}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="demo-simple-select-label">
//                   FAM Asset
//                 </InputLabel>
//                 <Select
//                   labelId="demo-simple-select-label"
//                   id="demo-simple-select"
//                   value=""
//                   label="VIEW"
//                 >
//                   <MenuItem value="Default View">Default View</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//           <Box
//             sx={{
//               p: 1,
//             }}
//           >
//             <Stack spacing={2} direction="row">
//               <Button className="blue-button">New FAM Asset</Button>
//               <Button className="blue-button">Attach</Button>
//               <Button className="blue-button">Customize View</Button>
//             </Stack>
//           </Box>
//           <AgGridPaginatedTable
//             getTableRows={undefined}
//             columns={BgFAMAssetTable}
//             refreshCounter={0}
//           />
//         </TabPanel>
//       </Box>
//       )}
//     </>
//   );
// }
